import React, { useState, useContext, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import { makeStyles } from '@material-ui/styles';
import { DateTimeContext } from '../../../services/dataTime/dateTime.context';
import { urlConfig } from '../../../config/urlConfig';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { CreateMeetingContext } from '../../../services/create-meeting/create-meeting.context';
import './style.css';
import { ProfileContext } from '../../../services/profile/profile.context';
import {
  accessTokenRequest,
  sendRequest,
} from '../../../services/global/global.service';

const useStyles = makeStyles({
  root: {
    width: 900,
    overflowY: 'scroll',
    height: 400,
  },
  table: {
    minWidth: 700,
  },
  header: {
    backgroundColor: '#f7f7f7',
  },
  side: {
    backgroundColor: '#f7f7f7',
    borderRight: 'solid 1px #e0e0e0',
    padding: 0,
    textAlign: 'center',
    position: 'relative',
  },
  rows: {
    height: 45,
  },
  container: {
    overflowX: 'auto',
    overflowY: 'auto',
  },
  select: {
    width: 500,
  },
  spanTime: {
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    fontSize: 10,
    color: '#70757a',
    display: 'block',
    backgroundColor: '#fff',
  },
  wrapper: {
    position: 'relative',
    margin: '10px 0',
    width: 'max-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
  },
});

export const MeetingTimeTable = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [commonTimes, setCommonTimes] = useState('');
  const [commonTimeStatus, setCommonTimeStatus] = useState('');
  const [nextSevenDate, setNextSevenDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { states } = useContext(CreateMeetingContext);
  const { user } = useContext(ProfileContext);
  const { startDate, timeZone, startDateChange } = useContext(DateTimeContext);
  const { users, meeting } = states;
  const hostUserName = user && user.username;

  useEffect(() => {
    let today = moment().format();
    let dates = [];
    for (let i = 0; i < 7; i++) {
      dates.push({
        weekDayIndex: parseInt(moment(today).add(i, 'days').format('d')),
        date: moment(today).add(i, 'days').format('YYYY-MM-DD'),
      });
      setNextSevenDate(dates);
    }
    return false;
  }, []);

  const columns = [
    { id: 'time', label: '', minWidth: 100, width: 100, height: 500 },
    { id: 'sun', label: 'Sun', minWidth: 100 },
    { id: 'mon', label: 'Mon', minWidth: 100 },
    { id: 'tue', label: 'Tue', minWidth: 100 },
    { id: 'wed', label: 'Wed', minWidth: 100 },
    { id: 'thu', label: 'Thu', minWidth: 100 },
    { id: 'fri', label: 'Fri', minWidth: 100 },
    { id: 'sat', label: 'Sat', minWidth: 100 },
  ];

  let weekDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  let tableRows = [];

  const createData = (time, sun, mon, tue, wed, thu, fri, sat) => {
    return { time, sun, mon, tue, wed, thu, fri, sat };
  };

  const setPreferTime = (tempTime, day, index) => {
    if (moment().format('ddd').toLowerCase() === day) {
      startDateChange(
        `${moment().format('YYYY-MM-DD')}T${tempTime.format('HH:00')}`,
        meeting && meeting.id && meeting.id
      );
    } else {
      nextSevenDate.map((item) => {
        if (item.weekDayIndex === index) {
          startDateChange(
            `${item.date}T${tempTime.format('HH:00')}`,
            meeting && meeting.id && meeting.id
          );
        }
        return null;
      });
    }
    setOpen(false);
  };

  for (let i = 0; i < 24; i++) {
    let row = [];
    let tempDate = new Date();
    tempDate.setHours(i);

    let tempTime = moment(tempDate);

    row.push(
      <Box className={classes.spanTime}>
        <Typography variant='caption' style={{ marginRight: 2 }}>
          {tempTime.format('h')}
        </Typography>
        <Typography variant='caption'>{tempTime.format('A')}</Typography>
      </Box>
    );

    weekDays.map((day, dayIndex) => {
      if (
        commonTimes &&
        commonTimes[day].length > 0 &&
        commonTimes[day].includes(parseInt(i))
      ) {
        row.push(
          <Button
            className='selected cube'
            onClick={() => setPreferTime(tempTime, day, dayIndex)}
          ></Button>
        );
      } else {
        row.push('');
      }
      return null;
    });
    tableRows.push(createData.apply(null, row));
  }

  const handleClickOpen = () => {
    const userData = [];

    users && users.length > 0 && users.map((user) => userData.push(user.username));

    if (userData.length > 0) {
      setIsLoading(true);

      accessTokenRequest()
        .then((response) => {
          sendRequest(urlConfig.timeTable, response, 'post', {
            meeting_date: moment(startDate).format('YYYY-MM-DD'),
            time_zone_destination: timeZone,
            users: [...userData, hostUserName],
          })
            .then((res) => {
              setCommonTimes(res.data);

              setOpen(true);
              setCommonTimeStatus('');
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
              if (err.message === 'Network Error') {
                setCommonTimeStatus(err.message);
              } else if (err.response) {
                setCommonTimeStatus(err.response.data.detail);
              }
            });
        })
        .catch((err) => {
          console.log('refresh token error: ', err);
          setIsLoading(false);
        });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Box mt={4} className={classes.wrapper}>
        <Button
          size='small'
          variant='contained'
          startIcon={<QueryBuilderIcon />}
          onClick={handleClickOpen}
          disabled={isLoading}
        >
          get prefer time
        </Button>
        {isLoading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </Box>

      <Box>
        <Typography variant='caption' color='error'>
          {commonTimeStatus}
        </Typography>
      </Box>
      <Dialog
        open={open}
        keepMounted
        maxWidth='md'
        className={classes.dialog}
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle>Prefer Time</DialogTitle>

        <DialogContent style={{ overflowY: 'hidden' }}>
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table
                stickyHeaders
                size='small'
                aria-label='sticky table'
                id='timeTable'
              >
                <TableHead className={classes.header}>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align='center'
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role='checkbox'
                        className={classes.rows}
                        tabIndex={-1}
                        key={index}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              className={classes.side}
                              key={column.id}
                              align='center'
                            >
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} size='small' color='primary'>
            close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
